export default "__VITE_ASSET__b3cbef26__"